var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { Component } from 'react';
import { Button, Modal, Checkbox, Snackbar } from '@cimpress/react-components';
import DatePicker from '@cimpress/react-components/lib/DatePicker';
import request from '../../services/request';
import moment from 'moment';

var WebsiteDownload =
/** @class */
function (_super) {
  __extends(WebsiteDownload, _super);

  function WebsiteDownload(props) {
    var _this = _super.call(this, props) || this;

    _this.onStartDateChange = function (selectedDate) {
      if (selectedDate) {
        _this.setState({
          startDate: selectedDate
        });
      }
    };

    _this.onEndDateChange = function (selectedDate) {
      if (selectedDate) {
        _this.setState({
          endDate: selectedDate
        });
      }
    };

    _this.onChange = function (e) {
      // eslint-disable-next-line react/no-access-state-in-setstate
      _this.setState({
        includeSales: !_this.state.includeSales
      });
    };

    _this.isValidDate = function (current) {
      var startDate = moment().subtract(9, 'month');
      var endDate = moment();
      return current.isAfter(startDate) && current.isBefore(endDate);
    };

    _this.submitJob = function () {
      var _a = _this.state,
          startDate = _a.startDate,
          endDate = _a.endDate,
          includeSales = _a.includeSales;
      var stgUrl = 'https://stg-startingpriceapi.financialflows.cimpress.io/v1/jobs/costExport';
      var prdUrl = 'https://startingpriceapi.financialflows.cimpress.io/v1/jobs/costExport';
      var body = {
        sku: _this.props.sku,
        salesInfo: {
          includeSalesInfo: includeSales
        }
      };

      if (includeSales) {
        body.salesInfo.date = {
          start: startDate.format('YYYY-MM-DD'),
          end: endDate.format('YYYY-MM-DD')
        };
      }

      var endpoint = _this.props.isProduction ? prdUrl : stgUrl;
      return request(endpoint, 'POST', JSON.stringify(body));
    };

    _this.onHideSnackbar = function () {
      _this.setState({
        showSnackBar: false
      });
    };

    _this.state = {
      startDate: undefined,
      endDate: undefined,
      show: _this.props.showWebsiteDownload,
      includeSales: false,
      showSnackBar: false,
      snackBarStyle: 'success'
    };
    return _this;
  }

  WebsiteDownload.prototype.componentWillUnmount = function () {
    this.setState({
      startDate: undefined,
      endDate: undefined,
      show: this.props.showWebsiteDownload,
      includeSales: false,
      showSnackBar: false,
      snackBarStyle: 'success'
    });
  };

  WebsiteDownload.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.showWebsiteDownload !== this.props.showWebsiteDownload) {
      this.setState({
        show: this.props.showWebsiteDownload
      });
    }
  };

  WebsiteDownload.prototype.render = function () {
    var _this = this;

    var _a = this.state,
        startDate = _a.startDate,
        endDate = _a.endDate,
        show = _a.show,
        showSnackBar = _a.showSnackBar,
        snackBarStyle = _a.snackBarStyle;
    return React.createElement(React.Fragment, null, React.createElement(Snackbar, {
      show: showSnackBar,
      bsStyle: snackBarStyle,
      delay: 3000,
      onHideSnackbar: this.onHideSnackbar
    }, snackBarStyle === 'success' ? 'Job Submitted Successfully' : 'Error in submitting Export Job'), React.createElement(Modal, {
      className: "website-download-modal",
      show: show,
      onRequestHide: function onRequestHide() {
        _this.props.toggleShowWebsite(false);
      },
      title: "Download Website Price and Cost",
      closeButton: true,
      footer: React.createElement("div", null, React.createElement(Button, {
        className: "btn btn-default",
        onClick: function onClick() {
          _this.props.toggleShowWebsite(false);
        }
      }, "Close"), React.createElement(Button, {
        type: "primary",
        className: "btn btn-primary",
        onClick: function onClick() {
          _this.submitJob().then(function () {
            _this.setState({
              showSnackBar: true,
              snackBarStyle: 'success'
            }, function () {
              return _this.props.toggleShowWebsite(false);
            });
          }).catch(function () {
            _this.setState({
              showSnackBar: true,
              snackBarStyle: 'warning'
            }, function () {
              return _this.props.toggleShowWebsite(false);
            });
          });

          _this.props.toggleShowWebsite(false);
        }
      }, "Submit"))
    }, React.createElement("div", null, React.createElement("p", null, React.createElement("b", null, "SKU:"), " ", React.createElement("span", null, this.props.sku)), React.createElement("div", null, React.createElement("div", {
      style: {
        marginBottom: '15px'
      }
    }, React.createElement(Checkbox, {
      label: "Include sales information for below time period:",
      checked: this.state.includeSales,
      payload: "includeSales",
      onChange: this.onChange
    })), React.createElement("div", {
      className: "row"
    }, React.createElement("div", {
      className: "col-md-4 config-date-picker"
    }, React.createElement(DatePicker, {
      disabled: !this.state.includeSales,
      closeOnSelect: true,
      value: startDate,
      placeholder: "Start Date",
      timeFormat: false,
      onChange: this.onStartDateChange,
      isValidDate: this.isValidDate
    })), React.createElement("div", {
      className: "col-md-2"
    }), React.createElement("div", {
      className: "col-md-4 config-date-picker"
    }, React.createElement(DatePicker, {
      disabled: !this.state.includeSales,
      closeOnSelect: true,
      value: endDate,
      placeholder: "End Date",
      timeFormat: false,
      onChange: this.onEndDateChange
    })))))));
  };

  return WebsiteDownload;
}(Component);

export default WebsiteDownload;